<template>
  <div>
    <Yukleniyor :data="lo"></Yukleniyor>
    <el-alert
      title="Güncel Alacak Yok"
      type="success"
      :closable="false"
      v-if="!Tahakkuklar && !lo">
    </el-alert>
    <el-table
      class="table-xs"
      style="width: 100%"
      width="100%"
      v-if="Tahakkuklar"
      :data="Tahakkuklar"
      show-summary
      :height="Height"
      :summary-method="TableFooter"
      @current-change="KisiSecim">
      <el-table-column
        label="Ad Soyad"
        prop="AdSoyad">
      </el-table-column>
      <el-table-column
        label="Tutar"
        prop="Tutar"
        width="90"
        align="right">
      </el-table-column>
      <el-table-column
        label="Zam"
        prop="Zam"
        width="90"
        align="right">
      </el-table-column>
      <el-table-column
        label="Ödenecek"
        prop="Odenecek"
        width="90"
        align="right">
      </el-table-column>
    </el-table>


  </div>
</template>

<script>
import Yukleniyor from "../../../../../Doc/Yukleniyor";

export default {
  components: {Yukleniyor},
  props: ["Bina_id"],
  data() {
    return {
      lo: true,
      Height: window.innerHeight - 270,
      Tahakkuklar: null,
      AltToplam: {
        Tutar: 0,
        Zam: 0,
        Odenecek: 0
      }
    }
  },
  methods: {
    KisiSecim(val) {
      this.$router.push('/vezne/tahsilat/' + val.Kisi_id);
    },
    SayfaYukle() {
      this.$store.dispatch("Get", {path: 'yonetim/bina/ekran/' + this.Bina_id + '/tahakkuk'})
        .then(response => {
          if (response.Durum === 'OK') {
            this.Tahakkuklar = response.Liste
            this.AltToplam = response.AltToplam
            this.lo = false
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });
    },
    TableFooter() {
      const sums = [];
      sums[1] = this.AltToplam.Tutar;
      sums[2] = this.AltToplam.Zam;
      sums[3] = this.AltToplam.Odenecek;
      return sums;
    },
  },
  created() {
    this.SayfaYukle();

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Yonetim/bina/Ekran/Detay/Tahakkuklar.vue